import { forwardRef, createElement } from 'react';

function IconCircleTick(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm4.403 3.867a.75.75 0 01.282.938l-.052.098-5.091 8a.75.75 0 01-1.145.145l-.074-.08-2.909-3.636a.75.75 0 011.096-1.018l.076.081 2.253 2.817 4.528-7.115a.75.75 0 011.036-.23z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var CircleTick = /*#__PURE__*/forwardRef(IconCircleTick);

export default CircleTick;
//# sourceMappingURL=CircleTick.js.map
